import React from "react";
import "./cta.css";
const CTA = () => {
  return (
    <div className="gpt3__cta section__margin">
      <div className="gpt3__cta-content">
        <p>Request Early Access to Get Started</p>
        <h2>Register today & start exploring the endless possiblities.</h2>
      </div>
      <div className="gpt3__cta-btn">
        <button>Get Started</button>
      </div>
    </div>
  );
};

export default CTA;
